(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "./index.less", "../transition", "./mixins", "../_util/vantScroll", "../_mixins/vantTouch", "../_util/vantEvent", "../_util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../transition"), require("./mixins"), require("../_util/vantScroll"), require("../_mixins/vantTouch"), require("../_util/vantEvent"), require("../_util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.defineProperty, global.index, global.transition, global.mixins, global.vantScroll, global.vantTouch, global.vantEvent, global._util);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _defineProperty2, _index, _transition, _mixins, _vantScroll, _vantTouch, _vantEvent, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _transition = _interopRequireDefault(_transition);
  _mixins = _interopRequireDefault(_mixins);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isPopupShow,
          expression: "isPopupShow"
        }],
        staticClass: "nx-popup",
        class: [_vm.hasMask ? 'with-mask' : '', _vm.largeRadius ? 'large-radius' : '', _vm.position]
      }, [_c('transition', {
        attrs: {
          "name": "nx-mask-fade"
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.hasMask && _vm.isPopupBoxShow,
          expression: "hasMask && isPopupBoxShow"
        }],
        staticClass: "nx-popup-mask",
        on: {
          "click": _vm.$_onPopupMaskClick
        }
      })]), _c('nx-transition', {
        attrs: {
          "name": _vm.transition
        },
        on: {
          "before-enter": _vm.$_onPopupTransitionStart,
          "before-leave": _vm.$_onPopupTransitionStart,
          "after-enter": _vm.$_onPopupTransitionEnd,
          "after-leave": _vm.$_onPopupTransitionEnd
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isPopupBoxShow,
          expression: "isPopupBoxShow"
        }],
        ref: "popupContent",
        staticClass: "nx-popup-box",
        class: [_vm.transition]
      }, [_vm._t("default")], 2)])], 1);
    },
    name: 'nx-popup',
    mixins: [_mixins.default, _vantTouch.TouchMixin],
    components: {
      'nx-transition': _transition.default
    },
    props: {
      position: {
        type: String,
        default: 'center'
      },
      transition: {
        type: String,
        default: function _default() {
          switch (this.position) {
            case 'sheets-bottom':
              return 'nx-slide-up-sheets';

            case 'bottom':
              return 'nx-slide-up';

            /* istanbul ignore next */

            case 'top':
              return 'nx-slide-down';

            /* istanbul ignore next */

            case 'left':
              return 'nx-slide-right';

            /* istanbul ignore next */

            case 'right':
              return 'nx-slide-left';

            default:
              return 'nx-fade';
            // fade/fade-bounce/fade-slide/fade-zoom
          }
        }
      },
      lockScroll: {
        type: Boolean,
        default: true
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          return _util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1;
        }
      },
      preventScroll: {
        type: Boolean,
        default: false
      },
      preventScrollExclude: {
        type: [String, Function],
        default: function _default() {
          return '';
        }
      },
      // 是否开启自动聚焦
      ariaAutoFocus: {
        type: Boolean,
        default: true
      },
      ariaPopupLabel: {
        type: String,
        default: '弹出式窗口，'
      },
      // openAriaActive该属性废弃
      openAriaActive: {
        type: Boolean,
        default: true
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      multiplePopup: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      slideDownOut: function slideDownOut() {
        if (this.slideDownDisappear == undefined) {
          return this.maskClosable;
        } else {
          return this.slideDownDisappear;
        }
      }
    },
    data: function data() {
      return {
        // controle popup mask & popup box
        isPopupShow: false,
        // controle popup box
        isPopupBoxShow: false,
        // transtion lock
        isAnimation: false,
        largeRadius: false,
        lastActiveElement: null,
        popupNumber: 0,
        maskClosableInside: false
      };
    },
    watch: {
      value: function value(val) {
        var _this = this;

        /* istanbul ignore next */
        if (val) {
          if (this.isAnimation) {
            setTimeout(function () {
              _this.$_showPopupBox();
            }, 50);
          } else {
            this.$_showPopupBox();
          }
        } else {
          this.$_hidePopupBox();
        }

        if (this.backClosePopup) {
          var stateName = 'popup-showTime';

          if (val) {
            // 记录组件显示的时间
            this.showTime = Date.now();

            if (this.backClosePopupCustomEvent === 'popstate') {
              history.pushState((0, _defineProperty2.default)({}, stateName, this.showTime), '');
            } else {
              // 自定义事件（注：需要将浏览器原生事件关掉）
              window.$__nxPopupShowTimeList.push((0, _defineProperty2.default)({}, stateName, this.showTime));
            }

            window.addEventListener(this.backClosePopupCustomEvent, this.onPopState);
          } else {
            window.removeEventListener(this.backClosePopupCustomEvent, this.onPopState); // 当弹窗是点击蒙层关闭、事件关闭、下拉关闭时候执行（非返回键），history回退一条记录

            if (this.backClosePopupCustomEvent === 'popstate') {
              if (history.state && history.state[stateName] === this.showTime) {
                history.back();
              }
            } else {
              // 自定义事件回退一条记录
              var lastItem = window.$__nxPopupShowTimeList[window.$__nxPopupShowTimeList.length - 1];

              if (lastItem && lastItem[stateName] === this.showTime) {
                window.$__nxPopupShowTimeList.pop();
              }
            }
          }
        }
      },
      preventScrollExclude: function preventScrollExclude(val, oldVal) {
        // remove old listener before add

        /* istanbul ignore next */
        this.$_preventScrollExclude(false, oldVal);
        /* istanbul ignore next */

        this.$_preventScrollExclude(true, val);
      }
    },
    beforeCreate: function beforeCreate() {
      if (!Array.isArray(window.$__nxPopupShowTimeList)) window.$__nxPopupShowTimeList = [];
    },
    mounted: function mounted() {
      this.value && this.$_showPopupBox();
    },
    methods: {
      onPopState: function onPopState() {
        var _this2 = this;

        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          var stateName, lastItem;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  stateName = 'popup-showTime';

                  if (!(_this2.backClosePopupCustomEvent === 'popstate')) {
                    _context.next = 6;
                    break;
                  }

                  if (!(history.state && history.state[stateName] >= _this2.showTime)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return");

                case 4:
                  _context.next = 12;
                  break;

                case 6:
                  // 自定义事件： 注 用dialog的js方法调用多个弹窗时会有问题，
                  lastItem = window.$__nxPopupShowTimeList[window.$__nxPopupShowTimeList.length - 1];

                  if (!(lastItem && lastItem[stateName] > _this2.showTime)) {
                    _context.next = 11;
                    break;
                  }

                  return _context.abrupt("return");

                case 11:
                  window.$__nxPopupShowTimeList.pop();

                case 12:
                  _this2.$emit('beforeBackClosePopupHide');

                  _this2.$emit('input', false);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      onPopupNumber: function onPopupNumber(val) {
        // val-true，增加弹窗；val-false，弹窗消失
        var body = document.querySelector('body');
        var nextPopupNumber = 0;

        if (this.multiplePopup) {
          // 应对多个弹窗的情况，记录当前弹窗数量
          var currentPopupNumber = Number(body.getAttribute('data-nx-popup-number') || 0);

          if (val) {
            nextPopupNumber = Math.max(currentPopupNumber + 1, 0);
            body.setAttribute('data-nx-popup-number', String(nextPopupNumber));
          } else {
            nextPopupNumber = Math.max(currentPopupNumber - 1, 0);
            body.setAttribute('data-nx-popup-number', String(nextPopupNumber));
          }
        }

        this.popupNumber = nextPopupNumber;
      },
      // MARK: private methods
      $_showPopupBox: function $_showPopupBox() {
        this.onPopupNumber(true);
        this.isPopupShow = true;
        this.isAnimation = true; // popup box enter the animation after popup show

        this.isPopupBoxShow = true;
        this.$_delaySetMaskClosableClick(true);
        /* istanbul ignore if */

        this.lockScroll && this.$_lockScroll(this.lockScroll);
        this.preventScroll && this.$_preventScroll(true);
        this.$_addAttrsFocus(true);
      },
      $_hidePopupBox: function $_hidePopupBox() {
        this.onPopupNumber(false);
        this.isAnimation = true;
        this.isPopupBoxShow = false;
        this.$_delaySetMaskClosableClick(false);
        this.preventScroll && this.$_preventScroll(false);
        this.$emit('input', false);
        this.lockScroll && this.$_lockScroll(false);
        this.$_addAttrsFocus(false);
      },
      // 无障碍-焦点管理
      $_addAttrsFocus: function $_addAttrsFocus(showPopup) {
        var _this3 = this;

        if (!this.openAriaActive || !this.ariaAutoFocus) return;

        if (showPopup) {
          // 保存之前的焦点
          this.lastActiveElement = document.activeElement;
          this.$nextTick(function () {
            var popupContentEl = _this3.$refs.popupContent; // 聚焦到后代dom中，属性为nx-popup-aria-auto-focus-el的第一个元素上

            var ariaAutoFocusEl = popupContentEl && popupContentEl.querySelector("[nx-popup-aria-auto-focus='true']");

            if (ariaAutoFocusEl) {
              ariaAutoFocusEl.tabIndex = ariaAutoFocusEl.tabIndex && ariaAutoFocusEl.tabIndex > 0 ? ariaAutoFocusEl.tabIndex : 999; // 保存原来的ariaLabel

              ariaAutoFocusEl.style.outline = 'none';

              var _ariaLabel = ariaAutoFocusEl.ariaLabel || '';

              ariaAutoFocusEl.ariaLabel = _this3.ariaPopupLabel + _ariaLabel;

              _this3.$nextTick(function () {
                // 如果不存在聚焦元素，则聚焦到外框上
                ariaAutoFocusEl.focus(); // 还原

                setTimeout(function () {
                  ariaAutoFocusEl.ariaLabel = _ariaLabel;
                }, 1000);
              });
            }
          });
        } else {
          // 还原焦点
          this.lastActiveElement && this.lastActiveElement.focus();
          this.$nextTick(function () {
            _this3.lastActiveElement = null;
          });
        }
      },
      $_lockScroll: function $_lockScroll(isLock) {
        var body = document.querySelector('body');

        if (isLock) {
          if (this.isWebviewFull) {
            body.classList.add('nx-popup-lock-scroll-overflow-hidden');
            this.$_addLock(true);
          } else {
            // 多个弹窗时，只执行第一次。当没有multiplePopup，popupNumber为0
            if (this.popupNumber <= 1) {
              this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
              body.classList.add('nx-popup-lock-scroll');
              body.style.top = "-".concat(this.scrollTop, "px");
            }
          }
        } else {
          if (this.isWebviewFull) {
            // 剩余弹窗数量为0的时候移除
            !this.popupNumber && body.classList.remove('nx-popup-lock-scroll-overflow-hidden');
            this.$_addLock(false);
          } else {
            if (!this.popupNumber) {
              body.classList.remove('nx-popup-lock-scroll');
              body.style.top = '';
              window.scrollTo(0, this.scrollTop);
            }
          }
        }
      },
      onTouchMove: function onTouchMove(event) {
        this.touchMove(event); // '10'-向下；'01'-向上

        var direction = this.deltaY > 0 ? '10' : '01'; // 找到最近的可滚动的容器

        var el = (0, _vantScroll.getScroller)(event.target, this.$el);
        var scrollHeight = el.scrollHeight,
            offsetHeight = el.offsetHeight,
            scrollTop = el.scrollTop;
        var status = '11';

        if (scrollTop === 0) {
          // 该结果应该永远为 00 向上滚动到顶
          status = offsetHeight >= scrollHeight ? '00' : '01';
        } else if (scrollTop + offsetHeight >= scrollHeight - 1) {
          // 向下滚动到底
          status = '10';
        } //


        if (status !== '11' && this.direction === 'vertical' && !(parseInt(status, 2) & parseInt(direction, 2))) {
          (0, _vantEvent.preventDefault)(event, true);
        }
      },
      $_addLock: function $_addLock(isBind) {
        var handler = isBind ? 'addEventListener' : 'removeEventListener';
        document[handler]('touchmove', this.onTouchMove, {
          passive: false
        });
        document[handler]('touchstart', this.touchStart, {
          passive: false
        });
      },
      $_preventScroll: function $_preventScroll(isBind) {
        var handler = isBind ? 'addEventListener' : 'removeEventListener';
        var masker = this.$el.querySelector('.nx-popup-mask');
        var boxer = this.$el.querySelector('.nx-popup-box');
        masker && masker[handler]('touchmove', this.$_preventDefault, false);
        boxer && boxer[handler]('touchmove', this.$_preventDefault, false);
        this.$_preventScrollExclude(isBind);
      },
      $_preventScrollExclude: function $_preventScrollExclude(isBind, preventScrollExclude) {
        var handler = isBind ? 'addEventListener' : 'removeEventListener';
        preventScrollExclude = preventScrollExclude || this.preventScrollExclude;
        var excluder = preventScrollExclude && typeof preventScrollExclude === 'string' ? this.$el.querySelector(preventScrollExclude) : preventScrollExclude;
        excluder && excluder[handler]('touchmove', this.$_stopImmediatePropagation, false);
      },
      $_preventDefault: function $_preventDefault(event) {
        event.preventDefault();
      },
      $_stopImmediatePropagation: function $_stopImmediatePropagation(event) {
        /* istanbul ignore next */
        event.stopImmediatePropagation();
      },
      // MARK: event handler
      $_onPopupTransitionStart: function $_onPopupTransitionStart() {
        if (!this.isPopupBoxShow) {
          this.$emit('beforeHide');
          this.$emit('before-hide');
        } else {
          this.$emit('beforeShow');
          this.$emit('before-show');
        }
      },
      $_onPopupTransitionEnd: function $_onPopupTransitionEnd() {
        /* istanbul ignore next */
        if (!this.isAnimation) {
          return;
        }
        /* istanbul ignore next */


        if (!this.isPopupBoxShow) {
          // popup hide after popup box finish animation
          this.isPopupShow = false;
          this.$emit('hide');
        } else {
          this.$emit('show');
        }
        /* istanbul ignore next */


        this.isAnimation = false;
      },
      $_onPopupMaskClick: function $_onPopupMaskClick() {
        // 兼容scroll-view-two组件，防止弹窗弹出时直接被关闭
        if (this.maskClosable && this.maskClosableInside) {
          this.$emit('input', false); // this.$_hidePopupBox()
        }

        this.$emit('maskClick');
      },
      $_delaySetMaskClosableClick: function $_delaySetMaskClosableClick(value) {
        var _this4 = this;

        setTimeout(function () {
          _this4.maskClosableInside = value;
        }, 300);
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.lockScroll && this.$_lockScroll(false);
    }
  };
  _exports.default = _default2;
});